<template>
  <div class='EnbPedidos01'>
    <pedidos-header v-if="pedidos.length > 0 && !load"/>
    <div class="cont" v-if="pedidos.length > 0 && !load">
      <pedidos-list
      v-for="(p, key) in pedidos"
      :key="key"
      :data="p"
      />
    </div>
    <component
    :style="{ marginTop: '10%' }"
    :is="Prefes.spinner.tipo"
    :color="Prefes.spinner.cor"
    :size="Prefes.spinner.tipo === 'EnbSyncLoader' ? '12px' : '40px'"
    style="z-index: 999"
    v-if="load"
    />
    <enb-empty label="Você ainda não fez pedidos!" v-if="pedidos.length <= 0 && !load"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PedidosHeader from './header/PedidosHeader'
import PedidosList from './Itens/PedidosList'
import EnbEmpty from '../EnbEmpty'
import { loaders } from '@/components/Spinner'
export default {
  name: 'EnbPedidos01',
  components: { PedidosHeader, PedidosList, EnbEmpty, ...loaders },
  data () {
    return {
      pedidos: [],
      load: true
    }
  },
  computed: {
    ...mapGetters(['Profile', 'Prefes'])
  },
  methods: {
    ...mapActions(['GetPedidoClient'])
  },
  created () {
    let userid = typeof this.Profile.id === 'undefined' ? 0 : this.Profile.id
    this.GetPedidoClient(userid)
      .then(res => {
        this.load = false
        this.pedidos = res
      })
  }
}
</script>

<style scoped>
.EnbPedidos01 {
  width: 80%;
  min-height: 462px;
  margin: auto;
}

.cont {
  width: 100%;
}

@media (max-width: 500px) {
  .EnbPedidos01 {
    width: 100%;
  }
}

</style>
